<div style="padding: 20px 22px 16px 22px; min-width: 540px; max-width: 600px;">
  <!-- Header -->
  <div class="flex items-center gap-2 mb-1">
    <mat-icon style="color: #1C593D;">swap_horiz</mat-icon>
    <h2 style="font-size: 1rem; font-weight: 800; color: #1e5a3f; margin: 0;">Convertir saldo (wallet master)</h2>
    <button type="button" (click)="close()" class="ml-auto"
      style="display: inline-flex; align-items: center; justify-content: center; width: 28px; height: 28px; border: none; background: transparent; color: #9ca3af; cursor: pointer; border-radius: 6px;">
      <mat-icon style="font-size: 20px; width: 20px; height: 20px;">close</mat-icon>
    </button>
  </div>
  <div style="font-size: 0.72rem; color: #6b7280; margin-bottom: 14px;">
    Conversión Vita entre monedas de la wallet de negocio. Vita convierte
    fiat↔cripto y cripto↔cripto (no fiat↔fiat). Para pasar de un fiat a otro,
    convertí primero a USDT y luego USDT al fiat destino (dos conversiones).
  </div>

  <!-- ════════════ Resultado (tras ejecutar) ════════════ -->
  <ng-container *ngIf="result as r">
    <div style="background: linear-gradient(135deg, #f0fdf4, #d1fae5); border: 2px solid #1C593D; border-radius: 12px; padding: 16px;">
      <div class="flex items-center gap-2 mb-2">
        <mat-icon style="color: #166534;">check_circle</mat-icon>
        <span style="font-size: 0.9rem; font-weight: 800; color: #1e5a3f;">Conversión completada</span>
      </div>
      <div style="font-family: monospace; font-size: 1.25rem; font-weight: 900; color: #065f46; margin-bottom: 8px;">
        + {{ r.amountReceived | number:'1.2-8' }} {{ r.currencyReceived | uppercase }}
      </div>
      <div style="font-size: 0.74rem; color: #374151; font-family: monospace;">
        {{ r.amountSent | number:'1.2-8' }} {{ r.currencySent | uppercase }} →
        {{ r.amountReceived | number:'1.2-8' }} {{ r.currencyReceived | uppercase }}
        <span style="color: #6b7280;">@ {{ r.rate | number:'1.2-8' }} · {{ r.vitaStatus }}</span>
      </div>
    </div>
    <div class="flex justify-end mt-4">
      <button type="button" (click)="close()"
        style="padding: 9px 20px; border: none; border-radius: 10px; background: #1C593D; color: white; font-weight: 700; font-size: 0.84rem; cursor: pointer;">
        Cerrar
      </button>
    </div>
  </ng-container>

  <!-- ════════════ Formulario (antes de ejecutar) ════════════ -->
  <ng-container *ngIf="!result">
    <!-- Selectores origen / destino -->
    <div style="display: grid; grid-template-columns: 1fr 1fr; gap: 10px; margin-bottom: 10px;">
      <div>
        <label style="display:block; font-size: 0.68rem; font-weight: 700; color: #6b7280; text-transform: uppercase; letter-spacing: 0.4px; margin-bottom: 5px;">Origen</label>
        <select [(ngModel)]="from" (ngModelChange)="onFromChange()"
          style="width: 100%; border: 2px solid #bbf7d0; border-radius: 10px; padding: 9px 12px; font-weight: 800; color: #1e5a3f; background: white; font-family: monospace;">
          <option *ngFor="let c of currencyOptions; trackBy: trackByStr" [value]="c">{{ c | uppercase }}</option>
        </select>
        <div style="font-size: 0.66rem; color: #6b7280; margin-top: 4px;">
          Disponible: <b>{{ data.fromBalance | number:'1.2-8' }} {{ from | uppercase }}</b>
        </div>
      </div>
      <div>
        <label style="display:block; font-size: 0.68rem; font-weight: 700; color: #6b7280; text-transform: uppercase; letter-spacing: 0.4px; margin-bottom: 5px;">Destino</label>
        <select [(ngModel)]="to" (ngModelChange)="onToChange()"
          style="width: 100%; border: 2px solid #bbf7d0; border-radius: 10px; padding: 9px 12px; font-weight: 800; color: #1e5a3f; background: white; font-family: monospace;">
          <option *ngFor="let c of currencyOptions; trackBy: trackByStr" [value]="c">{{ c | uppercase }}</option>
        </select>
      </div>
    </div>

    <!-- Aviso de par inválido -->
    <div *ngIf="sameCurrency" style="display:flex; align-items:center; gap:6px; background:#fef2f2; border:1px solid #fecaca; border-radius:10px; padding:8px 12px; margin-bottom:10px;">
      <mat-icon style="font-size: 15px; width:15px; height:15px; color:#dc2626;">block</mat-icon>
      <span style="font-size: 0.72rem; color:#b91c1c; font-weight:600;">Origen y destino no pueden ser iguales.</span>
    </div>
    <div *ngIf="fiatToFiat" style="display:flex; align-items:flex-start; gap:6px; background:#fffbeb; border:1px solid #fde68a; border-radius:10px; padding:8px 12px; margin-bottom:10px;">
      <mat-icon style="font-size: 15px; width:15px; height:15px; color:#d97706; margin-top:1px;">info</mat-icon>
      <span style="font-size: 0.72rem; color:#92400e; font-weight:600;">
        Vita no convierte fiat→fiat directo. Elegí una cripto (USDT/USDC) en el destino;
        para llegar a otro fiat, hacé después una segunda conversión cripto→fiat.
      </span>
    </div>

    <!-- Monto -->
    <div style="margin-bottom: 12px;">
      <label style="display:block; font-size: 0.68rem; font-weight: 700; color: #6b7280; text-transform: uppercase; letter-spacing: 0.4px; margin-bottom: 5px;">Monto a convertir</label>
      <div style="display: flex; align-items: center; gap: 8px; border: 2px solid #bbf7d0; border-radius: 10px; padding: 9px 12px; background: white;"
        [style.border-color]="exceedsBalance ? '#fecaca' : '#bbf7d0'">
        <input type="number" [(ngModel)]="amount" (ngModelChange)="onAmountChange()" min="0" step="any"
          style="flex: 1; min-width: 0; border: none; outline: none; background: transparent; font-size: 1.05rem; font-weight: 800; color: #1e5a3f; font-family: monospace;" />
        <span style="font-family: monospace; font-weight: 700; color: #6b7280; font-size: 0.82rem;">{{ from | uppercase }}</span>
      </div>
      <div *ngIf="exceedsBalance" style="display:flex; align-items:center; gap:4px; margin-top: 4px; font-size: 0.66rem; color: #b45309; font-weight: 600;">
        <mat-icon style="font-size: 12px; width: 12px; height: 12px;">warning</mat-icon>
        Supera el saldo disponible ({{ data.fromBalance | number:'1.2-8' }} {{ from | uppercase }})
      </div>
    </div>

    <!-- Estado de cotización -->
    <div *ngIf="quoting" class="flex items-center gap-2 justify-center py-4" style="color: #6b7280; font-size: 0.78rem;">
      <mat-spinner diameter="20"></mat-spinner> Cotizando…
    </div>
    <div *ngIf="quoteError" style="display:flex; align-items:center; gap:8px; background: #fef2f2; border: 1px solid #fecaca; border-radius: 10px; padding: 10px 14px; margin-bottom: 10px;">
      <mat-icon style="font-size: 16px; width:16px; height:16px; color: #dc2626;">error</mat-icon>
      <span style="font-size: 0.78rem; color: #b91c1c; font-weight: 600;">{{ quoteError }}</span>
    </div>

    <!-- ════ Cotización ════ -->
    <div *ngIf="plan && !quoting" style="background: white; border: 2px solid #bfdbfe; border-radius: 12px; padding: 14px 16px; margin-bottom: 12px;">
      <div class="flex items-center gap-2 mb-2">
        <mat-icon style="color: #2563eb; font-size: 18px; width: 18px; height: 18px;">request_quote</mat-icon>
        <span style="font-size: 0.74rem; font-weight: 800; color: #1e40af; text-transform: uppercase; letter-spacing: 0.4px;">Cotización Vita</span>
      </div>

      <!-- Línea de conversión -->
      <div style="display: flex; align-items: center; gap: 8px; padding: 6px 0; border-bottom: 1px dashed #e5e7eb;">
        <div style="flex: 1; font-size: 0.74rem; color: #374151; font-weight: 600; font-family: monospace;">
          {{ plan.amountSent | number:'1.2-8' }} {{ plan.currencySent | uppercase }} →
          {{ plan.amountReceived | number:'1.2-8' }} {{ plan.currencyReceived | uppercase }}
        </div>
        <div style="text-align: right;">
          <div style="font-family: monospace; font-size: 0.7rem; color: #1e3a8a; font-weight: 700;">@ {{ plan.rateSell | number:'1.2-8' }}</div>
          <div *ngIf="plan.spreadPct !== null" style="font-size: 0.62rem; font-weight: 700;"
            [style.color]="(plan.spreadPct || 0) > 1 ? '#b45309' : '#6b7280'">
            dif. {{ plan.spreadPct | number:'1.2-2' }}%
          </div>
        </div>
      </div>

      <!-- Recibe estimado -->
      <div style="display: flex; align-items: center; gap: 10px; padding: 10px 0 4px 0;">
        <div style="display: flex; align-items: center; gap: 6px;">
          <mat-icon style="color: #1e40af; font-size: 18px; width: 18px; height: 18px;">savings</mat-icon>
          <span style="font-size: 0.8rem; font-weight: 800; color: #1e40af; text-transform: uppercase; letter-spacing: 0.4px;">Recibís (est.)</span>
        </div>
        <div class="ml-auto" style="font-family: monospace; font-size: 1.3rem; color: #1e3a8a; font-weight: 900;">
          {{ plan.amountReceived | number:'1.2-8' }} {{ plan.currencyReceived | uppercase }}
        </div>
      </div>

      <!-- Tasa efectiva -->
      <div style="background: #f8fafc; border: 1px solid #e2e8f0; border-radius: 8px; padding: 8px 10px; margin-top: 8px;">
        <div style="font-size: 0.6rem; color: #6b7280; font-weight: 700; text-transform: uppercase;">Tasa efectiva</div>
        <div style="font-family: monospace; font-size: 0.82rem; font-weight: 800; color: #1e3a8a;">
          1 {{ plan.currencySent | uppercase }} = {{ plan.effectiveRate | number:'1.2-8' }} {{ plan.currencyReceived | uppercase }}
        </div>
      </div>

      <div style="margin-top: 8px; font-size: 0.64rem; color: #6b7280; display:flex; align-items:center; gap: 4px;">
        <mat-icon style="font-size: 12px; width:12px; height:12px;">info</mat-icon>
        Estimación con tasas publicadas. La ejecución usa la tasa real de Vita.
      </div>
    </div>

    <!-- Error de ejecución -->
    <div *ngIf="submitError" style="display:flex; align-items:center; gap:8px; background: #fef2f2; border: 1px solid #fecaca; border-radius: 10px; padding: 10px 14px; margin-bottom: 10px;">
      <mat-icon style="font-size: 16px; width:16px; height:16px; color: #dc2626;">error</mat-icon>
      <span style="font-size: 0.78rem; color: #b91c1c; font-weight: 600;">{{ submitError }}</span>
    </div>

    <!-- Acciones -->
    <div class="flex justify-end gap-2 mt-2">
      <button type="button" (click)="close()" [disabled]="submitting"
        style="padding: 9px 18px; border: 2px solid #e5e7eb; border-radius: 10px; background: white; color: #374151; font-weight: 700; font-size: 0.84rem; cursor: pointer;">
        Cancelar
      </button>
      <button type="button" (click)="confirm()" [disabled]="!canConvert"
        [style.opacity]="canConvert ? 1 : 0.5"
        [style.cursor]="canConvert ? 'pointer' : 'not-allowed'"
        style="padding: 9px 22px; border: none; border-radius: 10px; background: #1C593D; color: white; font-weight: 800; font-size: 0.84rem; display: inline-flex; align-items: center; gap: 6px;">
        <mat-spinner *ngIf="submitting" diameter="16"></mat-spinner>
        {{ submitting ? 'Convirtiendo…' : 'Confirmar conversión' }}
      </button>
    </div>
  </ng-container>
</div>
